module.exports = __webpack_public_path__ + "static/Jessica-68eba950684ff2ada3ecd1069f410c2c.jpeg";